// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.glommer {
  margin-top: 15px;
  padding: 0px 15px 0 0;
}

ul.glommer li {
  width: 3em;
  height: 3em;
  text-align: center;
  line-height: 3em;
  border-radius: 5em;
  margin: 0 4em 0 0;
  display: inline-block;
  color: white;
  position: relative;
}

ul.glommer li span.number {
  z-index: 2;
  position: relative;
  font-size: 17px;
}

ul.glommer li span.info {
  z-index: 2;
  position: absolute;
  top: 28px;
  left: -28px;
  color: #1eabe3;
  width: 9rem;
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
}

ul.glommer li::before {
  content: '';
  position: absolute;
  top: 1.4em;
  left: -4em;
  width: 4em;
  height: 0.4em;
  z-index: 1;
}

ul.glommer li:first-child {
  margin-left: 0px;
}

ul.glommer li:last-child {
  margin-right: 0px;
}

ul.glommer li:first-child::before {
  display: none;
}

ul.glommer .active {
  background: #1eabe3;
}

ul.glommer li {
  background: #cecece;
}

ul.glommer li::before {
  background: #cecece;
}

ul.glommer li.active::before {
  background: #1eabe3;
}

ul.glommer li span.info {
  color: #cecece;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/glommer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".glommer {\n  margin-top: 15px;\n  padding: 0px 15px 0 0;\n}\n\nul.glommer li {\n  width: 3em;\n  height: 3em;\n  text-align: center;\n  line-height: 3em;\n  border-radius: 5em;\n  margin: 0 4em 0 0;\n  display: inline-block;\n  color: white;\n  position: relative;\n}\n\nul.glommer li span.number {\n  z-index: 2;\n  position: relative;\n  font-size: 17px;\n}\n\nul.glommer li span.info {\n  z-index: 2;\n  position: absolute;\n  top: 28px;\n  left: -28px;\n  color: #1eabe3;\n  width: 9rem;\n  text-align: center;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\nul.glommer li::before {\n  content: '';\n  position: absolute;\n  top: 1.4em;\n  left: -4em;\n  width: 4em;\n  height: 0.4em;\n  z-index: 1;\n}\n\nul.glommer li:first-child {\n  margin-left: 0px;\n}\n\nul.glommer li:last-child {\n  margin-right: 0px;\n}\n\nul.glommer li:first-child::before {\n  display: none;\n}\n\nul.glommer .active {\n  background: #1eabe3;\n}\n\nul.glommer li {\n  background: #cecece;\n}\n\nul.glommer li::before {\n  background: #cecece;\n}\n\nul.glommer li.active::before {\n  background: #1eabe3;\n}\n\nul.glommer li span.info {\n  color: #cecece;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
